// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro timestamp_Source.
 */
enum EnumTimestampSource {
    REMSIG = 'REMSIG', 
    TSA = 'TSA'
};
export default EnumTimestampSource;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumTimestampSource.REMSIG]: {caption: ''},
    [EnumTimestampSource.TSA]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
